import { Answer } from "@/data/questions";

export interface State {
  isDev: boolean;
  isMobile: boolean;

  isResultsPage: boolean;

  questionId: number;

  screenshot: string;

  carbonFootprint: number;
  economicProsperity: number;
  employment: number;
  healthHappinessAndWellbeing: number;
  wildlife: number;

  carbonFootprintParagraph: string;
  economicProsperityParagraph: string;
  employmentParagraph: string;
  healthHappinessAndWellbeingParagraph: string;
  wildlifeParagraph: string;

  submittedScore: boolean;
  submittedComment: boolean;

  selectedAnswers: Answer[];
}

export const defaultState: () => State = () => {
  return {
    questionId: 0,

    screenshot: "",

    carbonFootprint: 0,
    economicProsperity: 0,
    employment: 0,
    healthHappinessAndWellbeing: 0,
    wildlife: 0,

    carbonFootprintParagraph: "",
    economicProsperityParagraph: "",
    employmentParagraph: "",
    healthHappinessAndWellbeingParagraph: "",
    wildlifeParagraph: "",

    submittedScore: false,
    submittedComment: false,

    selectedAnswers: [],

    isResultsPage: false,

    isDev: process.env.NODE_ENV !== "production",
    // isMobile: window.matchMedia("only screen and (max-width: 760px)").matches
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ),
  };
};
